import { render, staticRenderFns } from "./ConsultaVenta.vue?vue&type=template&id=324a2e66"
import script from "./ConsultaVenta.vue?vue&type=script&lang=js"
export * from "./ConsultaVenta.vue?vue&type=script&lang=js"
import style0 from "./ConsultaVenta.vue?vue&type=style&index=0&id=324a2e66&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports